import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-59bdf281"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "transcode-param-item cms-card-block"
};
const _hoisted_2 = {
  class: ""
};
const _hoisted_3 = {
  class: "info"
};
const _hoisted_4 = {
  class: "info-title"
};
const _hoisted_5 = {
  class: "col-item"
};
const _hoisted_6 = {
  class: "col-item"
};
const _hoisted_7 = {
  class: "col-item"
};
const _hoisted_8 = {
  class: "info-select-room"
};
const _hoisted_9 = {
  class: "col-item"
};
const _hoisted_10 = {
  class: "col-item"
};
const _hoisted_11 = {
  class: "col-item"
};
import { getTextWidth } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'TranscodeParamItem',
  props: {
    col: {
      type: Array,
      default: ['30%', '33%', '33%']
    },
    formData: {
      type: Object,
      default: {
        ratio: '',
        h264: '',
        h265: ''
      }
    },
    title: {
      type: String,
      default: ''
    },
    selectOptinsObj: {
      type: Object,
      default: {
        ratio: [{
          value: '3840*2460',
          label: '3840*2460'
        }],
        h264: [{
          value: '8000',
          label: '8000'
        }],
        h265: [{
          value: '5600',
          label: '5600'
        }]
      }
    }
  },

  setup(__props) {
    const props = __props; //  内容超出时显示提示

    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(`".${target.innerText}`, {
        fontSize: '18px',
        fontWeight: 700
      });
      tipDisabled.value = target.offsetWidth < width;
    };

    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MPopper, {
        disabled: tipDisabled.value,
        placement: "top",
        trigger: "hover",
        content: _ctx.$t(__props.title)
      }, {
        reference: _withCtx(() => [_createElementVNode("div", {
          onMouseover: showTextTip,
          class: "cms-module-title title pointer"
        }, _toDisplayString(_ctx.$t(__props.title)), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('分辨率')), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('码率 (H.264)')), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('码率 (H.265)')), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_select, {
        "fit-input-width": "",
        modelValue: __props.formData.ratio,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.formData.ratio = $event),
        placeholder: "Select"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectOptinsObj.ratio, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("span", _hoisted_10, [_createVNode(_component_el_select, {
        "fit-input-width": "",
        modelValue: __props.formData.h264,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.formData.h264 = $event),
        placeholder: "Select"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectOptinsObj.h264, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("span", _hoisted_11, [_createVNode(_component_el_select, {
        "fit-input-width": "",
        modelValue: __props.formData.h265,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => __props.formData.h265 = $event),
        placeholder: "Select"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectOptinsObj.h265, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])])])]);
    };
  }

});